 function customRadio(radioName) {
    var radioButton = $('input[name="'+ radioName +'"]'),
        hiddenClass = 'wcs-hide',
        modeSelectedClass = 'wcs-shipping-mode-item--selected',
        selectedClass = 'selected',
        shippingModeClass = '.wcs-shipping-mode-item',
        agendadaBox = $('.wcs-shipping-mode-title--agendada');

    radioButton.on('change', function() {
        var clickedEl = $(this);
        clickedEl.parent().addClass(selectedClass);
        clickedEl.closest(shippingModeClass).addClass(modeSelectedClass);
        if(clickedEl.data('key') === 'SCH') {
            agendadaBox.removeClass(hiddenClass);
            agendadaBox.parent().removeClass(hiddenClass);
        }

        radioButton.not(this).each(function(index, el) {
            var currEl = $(el);
            currEl.parent().removeClass(selectedClass);
            currEl.closest(shippingModeClass).removeClass(modeSelectedClass);
            if(currEl.data('key') === 'SCH') {
                agendadaBox.addClass(hiddenClass);
                agendadaBox.parent().addClass(hiddenClass);
            }
        });
    });

    radioButton.each(function() {
        var curr = $(this);
        if(!curr.parent('.custom-radio').length) {
            if(curr.is(':checked')){
                curr.trigger('change');
                curr.trigger('click');
            }
        }
    });
}
